/* eslint-disable */
import $ from 'jquery';
import backbone from 'backbone';
import _ from 'underscore';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import * as _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import EditorView from '@bingads-webui-campaign-legacy/adextension-callout/view/extensionEditor';
import previewTemplate from '@bingads-webui-campaign-legacy/adextension-callout/template/extensionPreview.pug';
import rowTemplate from '@bingads-webui-campaign-legacy/adextension-callout/template/gridRowTemplate.pug';
import * as _panelDecorator from '@bingads-webui-campaign-react/panel-decorator';
var schema = window.globalLegacySchema.get('CalloutAdExtension');
var $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var SharedRepository = _SharedRepository.default;
var panelDecorator = _panelDecorator.panelDecorator;
var dialogOptions = {
  position: 'center',
  maxWidth: 1000
};
var i18nKeys = {
  title: 'AdExtensions_Callout_Editor_Title',
  subtitle: ['NewCampaign_CalloutAdExtension_Subtitle'],
  library_title: 'AdExtensions_Callout_Editor_Available',
  selected_title: 'AdExtensions_Callout_Editor_Selected',
  create_link: 'AdExtensions_Callout_Editor_CreateNew',
  create_title: 'AdExtensions_Callout_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Callout_Editor_Delete',
  delete_confirm: 'AdExtensions_Callout_Delete_Warning',
  edit_btn: 'AdExtensions_Callout_Editor_Edit',
  edit_title: 'AdExtensions_Callout_Dialog_Title_Edit',
  inlineAlert: 'AdExtensions_Callout_Max_Select_Notification'
};
var defaultRepositoryFactory = function (factoryOptions) {
  var schema = factoryOptions.schema;
  var updateContext = factoryOptions.updateContext;
  return new SharedRepository({
    schema: schema,
    afterChangeComitted: function () {
      if (_.isFunction(updateContext)) {
        updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
      }
    }
  });
};
var view = AssociationsEditorBase.extend({
  initialize: function (options) {
    var Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n: $i18n,
      panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName
    }) : dialogDecorator.decorate(EditorView, dialogOptions);
    var repositoryFactory = options.repositoryFactory || defaultRepositoryFactory;
    _.extend(options, {
      idField: 'Id',
      data: repositoryFactory({
        schema: schema,
        updateContext: options.updateContext
      }),
      template: {
        preview: previewTemplate,
        rowTemplate: rowTemplate
      },
      extensionType: 'CalloutExtension',
      maxSelectedItemsCount: options.maxSelectedItemsCount || 20,
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || ({}))
    });
    AssociationsEditorBase.prototype.initialize.apply(this, [options]);
  }
});
export default view;

